import EditorLayout from '@/components/yearbook/EditorLayout';

const Index = () => {
  return <EditorLayout />;
};

export default Index;
